import { render, staticRenderFns } from "./appForgotPassword.vue?vue&type=template&id=6cb093e1"
import script from "./appForgotPassword.vue?vue&type=script&lang=js"
export * from "./appForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./appForgotPassword.vue?vue&type=style&index=0&id=6cb093e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports